import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/apps')({
  head: () => ({
    meta: [{ title: 'Apps | Tekst' }],
  }),
  component: () => <Outlet />,
});
